import { TypographySM } from "@/components/typography/SM";
import { Settings } from "@/components/ui/SettingsSection";
import { LoadingCircle } from "@/components/ui/loadingCircle";
import { useAuth0 } from "@auth0/auth0-react";
import { UserNameRow } from "./UserNameRow";

function UserBasics() {
  const { user, isLoading } = useAuth0();

  if (!isLoading && !user?.email) return null;

  return (
    <Settings.Section title="Basics" description="Basic information about you">
      <UserNameRow />
      <Settings.Item title="Email address">
        {isLoading ? (
          <LoadingCircle />
        ) : (
          <TypographySM>{user?.email}</TypographySM>
        )}
      </Settings.Item>
    </Settings.Section>
  );
}

export default UserBasics;
